<app-entity-transaction-modal
  modalTitle="TRANSACTIONS"
  ariaLabelledBy="entity-investment-details-modal-title"
  [dataLoading]="dataLoading()"
  [dataAvailable]="dataAvailable()"
  [dataEmpty]="dataEmpty()"
  [columns]="columns()"
  [currentPage]="currentPage()"
  [sortField]="sortField()"
  [sortOrder]="sortOrder()"
  (sortChanged)="sort($event)"
  (searchChanged)="search($event)"
  (pageChanged)="page($event)">
  <ng-container entityInfo>
    <h2>Name: {{entityInvestment().name}}</h2>
    <h2>Type:
      @if (entityInvestment().type) {
        <span>{{entityInvestment().type}}</span>
      }
      @if (!entityInvestment().type) {
        <span class="fallback-text">(Empty)</span>
      }
    </h2>
    <h2>Market Value: {{entityInvestment().marketValue.displayValue}}</h2>
  </ng-container>
</app-entity-transaction-modal>
